import { doPolling } from '@ilyagershman/easy-poll';

interface TransactionData {
  data: any | null;
  error: {
    code: number;
    message: string;
  } | null;
}

export const useCheckoutListener = async (transactionId: string, providerList: Array<any>): Promise<TransactionData> => {
  const cart = useCart();
  try {
    const apiResult: any = await doPolling(
      () => $apiServer('/checkout', { query: { transaction_id: transactionId, count: cart.transaction_id_count } }),
      {
        maxPolls: 15,
        maxErrors: 5,
        interval: 1000,
        until: (result: any) => result.data?.data?.orders?.length === cart.transaction_id_count
      }
    ).init();

    const { data } = apiResult;
    let errorDetail: { code: number; message: string } | null = null;
    const errorExist = data?.data?.orders.find((k:any)=> k.error)
    
    if (data?.data?.length === 0 || data?.data?.orders?.length !== cart.transaction_id_count) {
      errorDetail = { code: 101, message: 'Unable to contact sellers' };
      return { data: null, error: errorDetail };
    } else if (errorExist) {
      errorDetail = {
        code: Number(errorExist.error.code),
        message: errorExist.error.message
      };
      return { data: null, error: errorDetail };
    }

    return { data: data.data.orders, error: errorDetail };
  } catch (error: any) {
    console.error('Error in useCheckoutListener:', error.message);
    return { data: null, error: { code: 500, message: error.message } };
  }
};